import { Component } from '@angular/core';
@Component({
  selector: 'axis-dropdown-tabs',
  template: `
    <span *ngIf="data.header" [setTabHeading]="data.header"></span>
    <span *ngIf="!data.header">{{data.heading}}</span>
    `
})
export class TabsDropdownTemplateComponent {
  data: any;
}
